<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    Energy Efficiency
                </v-card-title>
                <v-card-text>
                    <equipment-selector v-model="equip" type-filter="chiller*"></equipment-selector>
                    <v-slider
                            thumb-label="always"
                            label="Facet Groups"
                            v-model="facetGroups"
                            :max="20"
                            :min="1"
                            :step="1"
                    ></v-slider>
                    <date-range-selector v-model="range"></date-range-selector>
                    <v-switch
                        v-model="flattenSwitch"
                        label="Flatten Groups"
                        ></v-switch>
                   <v-switch
                        v-model="smoothedLineSwitch"
                        label="Smoothing Lines"
                        ></v-switch>
                </v-card-text>
                <v-card-text>
                     <facet-plot
                     :variable-x="chillerPowerVar"
                     :variable-y="chillerCOPVar"
                     variable-x-label="Electrical Load (kW)"
                     :facility_name="this.$store.state.pointsListStore.pointsList.facility_name"
                     :equipment_name="equip"
                     :date-range="range"
                     :on-only="true"
                     :facet-groups="facetGroups"
                     :variable-facet="returnTempVar"
                     :flatten-facet="flattenSwitch"
                     :smoothed-line="smoothedLineSwitch"
                     :smoothed-line-c-o-pclean="true"
                     :opacity="0.5"
                     :clean-data="true"
                     >
                     </facet-plot>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import DateRangeSelector from '../components/DateRangeSelector'
  import EquipmentSelector from '../components/EquipmentSelector'
  import FacetPlot from '../components/FacetPlot'
  import {mapGetters} from 'vuex'

  export default {
    name: 'EnergyEfficiency',
    components: { FacetPlot, EquipmentSelector, DateRangeSelector },
    computed: {
      ...mapGetters([
        'returnTempVar','chillerPowerVar', 'chillerCOPVar'
      ])
    },
    data () {
      return {
        flattenSwitch: true,
        range: null,
        facetGroups: 5,
        equip: null,
        smoothedLineSwitch: true
      }
    }
  }
</script>

<style scoped>

</style>
